import React from 'react';

import {observer, inject} from 'mobx-react';

import Button from 'material-ui/Button';

import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import MonitoringList from '../components/Monitoring/MonitoringList';
import DocumentList from '../components/DocumentList';
import DocumentHelper from '../helpers/Document';
import SyncData from '../components/SyncData';

class MonitoringContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            finishing_all: false,
            error_finishing_all: false,
        }
    }

    componentDidMount() {
        this.fetchData(this.state.offset);
    }

    fetchData(offset) {
        const document_store = this.props.document_store;
        const status = document_store.active_section;
        document_store.fetch({filter: {status}, offset});
    }

    changeSection(section) {
        const document_store = this.props.document_store;
        document_store.activeSection(section);
        document_store.fetch({filter: {status: section}});
    }

    getActiveClass(section) {
        const document_store = this.props.document_store;
        return (document_store.active_section === section) ? 'active' : '';
    }

    getSectionButton(section, title) {
        return (
            <Button
                onClick={this.changeSection.bind(this, section)}
                className={this.getActiveClass(section)}>
                {title}
            </Button>
        );
    }

    loadMore() {
        const document_store = this.props.document_store;
        if (document_store.last_fetch_length === document_store.limit && !document_store.fetching) {
            const offset = this.state.offset + document_store.limit;
            this.fetchData(offset);
            this.setState({offset});
        }
    }

    finishSessions = (data) => {
        this.setState({finishing_all: true});
        const {document_store} = this.props;
        document_store.finishAll(data)
            .then(() => {
                this.fetchData(0);
                this.setState({finishing_all: false, error_finishing_all: false});
                this.list.uncheckAll();
            })
            .catch((err) => {
                console.log('err', err);
                this.setState({error_finishing_all: true, finishing_all: false}, () => {
                    setTimeout(() => {
                        this.setState({error_finishing_all: false});
                    }, 4000)
                });
            });
    };

    render() {
        const document_store = this.props.document_store;
        const items = DocumentHelper.mapByStatus(document_store.documents, document_store.active_section);
        const List = (document_store.active_section === 'active') ? MonitoringList : DocumentList;

        return (
            <div>
                <Header/>
                <div className="container-fw">
                    <SideMenu/>

                    <div className="content">
                        <div className="flex-container">
                            <div className="filter-nav">
                                {this.getSectionButton('active', 'Ativos')}
                                {this.getSectionButton('pending', 'Pendentes')}
                                {this.getSectionButton('done', 'Finalizados')}
                            </div>
                            <List
                                wrappedComponentRef={instance => this.list = instance}
                                finishing_all={this.state.finishing_all}
                                error_finishing_all={this.state.error_finishing_all}
                                finishSessions={this.finishSessions}
                                updated_at={document_store.updated_at}
                                items={items}
                                is_fetched={document_store.fetched[document_store.active_section]}
                                fetching={document_store.fetching}
                                loadMore={this.loadMore.bind(this)}/>
                            <SyncData/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

let container = observer(MonitoringContainer);
container = inject(['document_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/containers/monitoring.js